import { render, staticRenderFns } from "./el-code.vue?vue&type=template&id=07c711fa&"
import script from "./el-code.vue?vue&type=script&lang=js&"
export * from "./el-code.vue?vue&type=script&lang=js&"
import style0 from "./el-code.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "el-code.vue"
export default component.exports